import { Props as BaseProps } from "@repo/dynamicEditor/src/helpers/sectionMapping";
import * as DEValidation from "@repo/dynamicEditor/src/helpers/validation";
import { ComponentValidationResult } from "@repo/dynamicEditor/src/models/mappedComponent";
import { MultiValidatorFn } from "@repo/helpers";

import { Rep, RepSegment } from "../../models";
import { RepSettings } from "../../models/settings";
import {
	conditionalField as baseConditionalField,
	componentType,
	MappedComponent,
	MappedDyno,
} from "./components/portalDynamicComponent";

export function getValidator<T>(entity: T) {
	return function (component: MappedComponent): MultiValidatorFn<any, ComponentValidationResult> {
		// switch (component.propertyName) {
		//     case "repDiscipline.endDate":
		//         const startDate = (entity as any as RepDiscipline).startDate;
		//         if (startDate)
		//             return (v: Date) =>
		//                 v < startDate ? "must be after start date" : DEValidation.getValidator(component)(v);
		//         break;
		// }

		switch (component.type as any) {
			case componentType.entryAddress:
				return validateChildren as any;
		}
		return DEValidation.getValidator(component);

		function validateChildren() {
			return component.components.map((c) => {
				return {
					component: c,
					value: getValidator(entity)(c)(c.propertyValue),
				};
			});
		}
	};
}

type SegmentPart = string &
	keyof RepSegment &
	keyof Rep &
	{ [K in keyof RepSegment]: RepSegment[K] extends number ? K : never }[keyof RepSegment];
const getSegmentPart = (propName: SegmentPart) => (rep: Rep, repSegment?: RepSegment) =>
	repSegment?.[propName] || rep?.[propName] || -1;
const getStateId = getSegmentPart("stateId");
const getChannelId = getSegmentPart("channelId");
const getMarketerId = getSegmentPart("marketerId");
const getBrandId = getSegmentPart("brandId");
const getBranchId = getSegmentPart("branchId");

export const shouldBeDisplayed = (props: ValidationData) => (component: MappedDyno) => {
	return matchConditional(component.visibleFor, props, true);
};

export const matchConditional = DEValidation.getMatchConditional(matchConditionalInternal);
/**
 * Returns true if condition matches, and false if not
 * Returns default value if no condition set
 * @param condition Conditional field to check
 * @param props Full set of data to compare conditions against
 */
function matchConditionalInternal(condition: conditionalField, props: ValidationData) {
	const { rep, repSegment } = props;
	let matched = true;
	if (!condition) return matched;
	if (
		!condition.stateId &&
		!condition.channelId &&
		!condition.branchId &&
		!condition.marketerId &&
		!condition.brandId &&
		!condition.property
	)
		return matched;

	const stateId = getStateId(rep, repSegment);
	if (condition.stateId) matched = matched && condition.stateId.includes(stateId);

	const channelId = getChannelId(rep, repSegment);
	if (condition.channelId) matched = matched && condition.channelId.includes(channelId);

	const marketerId = getMarketerId(rep, repSegment);
	if (condition.marketerId) matched = matched && condition.marketerId.includes(marketerId);

	const brandId = getBrandId(rep, repSegment);
	if (condition.brandId) matched = matched && condition.brandId.includes(brandId);

	const branchId = getBranchId(rep, repSegment);
	if (condition.branchId) matched = matched && condition.branchId.includes(branchId);

	return matched;
}

/** Updates conditional fields to map to properties inside section */
export const getSubSectionConditionalFor = DEValidation.getSubSectionConditionalFor;
export const getSectionConditionalFor = DEValidation.getSectionConditionalFor;

export interface ValidationData extends BaseProps {
	loaded: boolean;
	rep: Rep;
	repSegment?: RepSegment;
	settings: RepSettings;
}

export interface conditionalField extends baseConditionalField {
	stateId?: number[];
	channelId?: number[];
	marketerId?: number[];
	brandId?: number[];
	branchId?: number[];
}
